import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';

@Directive({
  selector: '[textareaAutoResize]'
})
export class TextareaAutoResizeDirective implements OnInit {

  constructor(private readonly elementRef: ElementRef) { }

  @HostListener('ngModelChange')
  onInput() {
    this.resize();
  }

  ngOnInit() {
    if (this.elementRef.nativeElement.scrollHeight) {
      setTimeout(() => this.resize());
    }
  }

  resize() {
    this.elementRef.nativeElement.style.height = '0';
    this.elementRef.nativeElement.style.height = this.elementRef.nativeElement.scrollHeight + 'px';
  }
}